import React, {useEffect} from 'react';
import AlfyCalendar from "../components/calendar/AlfyCalendar";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {Box} from "@mui/material";
import {VoterOverview} from "../components/appointment/VoterOverview";
import {BestDatesBoard} from "../components/appointment/BestDatesBoard";
import {AppointmentBottomDrawer} from "../components/appointment/AppointmentBottomDrawer";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import PollRangeTagBox from "../components/PollRangeTagBox";
import {AppointmentOverviewBottomButtons} from "../components/appointment/AppointmentOverviewBottomButtons";
import {userState} from "../states/user/userAtom";
import {useFetchMemberMe} from "../states/member/server";
import {useFetchAppointmentWithPoll} from "../states/appointment/server";
import {AskAttendanceBottomDrawer} from "../components/appointment/AskAttendanceBottomDrawer";
import {openAskAttendanceBottomDrawerState} from "../states/appointment/overviewAtom";
import {alfyToast, getShortenDateWithDayOfWeek} from "../utils/Utils";
import {useUserMe} from "../states/user/server";
import {useNavbar} from "../states/common/client";

const AppointmentOverviewPage: React.FC = () => {
    // states
    const user = useRecoilValue(userState);
    const setOpenAskAttendanceBottomDrawer = useSetRecoilState(openAskAttendanceBottomDrawerState)

    // hooks
    const [searchParams] = useSearchParams()
    const { setNavbarTitle, reset } = useNavbar()
    const navigate = useNavigate()
    const { id } = useParams();

    // others
    const appointmentId = id!
    const askAttendanceId = searchParams.get('askAttendanceId')

    // queries
    const { data: userMe } = useUserMe()
    const { data: memberMe } = useFetchMemberMe(appointmentId!)
    const { data: appointment } = useFetchAppointmentWithPoll(appointmentId)

    useEffect(() => {
        reset()
        setNavbarTitle("되는 날 현황")
    }, []);

    // '되는지 물어보기'를 통해 투표하러 들어온 경우
    useEffect(() => {
        if (!askAttendanceId || !appointment) {
            return
        }

        if (!userMe) {
            alfyToast("로그인 후 이용해주세요.")
            navigate(`/login?redirect=/appointments/${appointmentId}?askAttendanceId=${askAttendanceId}`)
        }

        if (!memberMe) {
            alfyToast("아직 약속의 멤버가 아닙니다. 아래 '나도 날짜 고르기' 버튼을 눌러 투표에 참여하세요.")
            return
        }

        const targetMemberPollItem = appointment.memberPollItems.find(memberPollItem =>
            memberPollItem.pollItem.id === askAttendanceId && memberPollItem.member.id === memberMe.id)
        if (targetMemberPollItem && targetMemberPollItem.attendType !== 'NOT_SURE') {
            alfyToast(`${getShortenDateWithDayOfWeek(targetMemberPollItem.pollItem.date)}에 대해 이미 투표하셨습니다.`)
        } else {
            setOpenAskAttendanceBottomDrawer(true)
        }
    }, [appointment, askAttendanceId, memberMe]);

    if (!appointment) {
        return <></>;
    }

    return (
        <div className={"fullscreen"}>
            {askAttendanceId && <AskAttendanceBottomDrawer/>}
            <AppointmentBottomDrawer />
            <Box height={"30px"}/>
            <div className="container">
                <span className={"primary-title-text"}>지금까지 참여한 사람들이<br/>만날 수 있는 날짜에요</span>
                <Box height={"8px"}/>
                <PollRangeTagBox appointment={appointment} />
            </div>
            <Box height={"20px"}/>
            <VoterOverview voters={appointment.getVotedMembers()} />
            <Box height={"15px"}/>
            <BestDatesBoard datePollInfos={appointment.getTop3PollInfos()} />
            <Box height={"15px"}/>
            <AlfyCalendar
                activeDates={appointment.getActiveDates()}
                datePollInfos={appointment.toDatePollInfos()}
                bestPollInfos={appointment.getBestPollInfos()}
            />
            <AppointmentOverviewBottomButtons appointmentId={appointmentId} />
        </div>
    );
}

export default AppointmentOverviewPage;